<template>
  <header class="page-title-bar mb-2 px-0">
    <div class="row text-center text-sm-left">
      <div class="col">
        <div class="d-inline-block mr-2">
          <span>Folio enmienda: </span><strong>{{ amendment.folio_number }}</strong>
        </div>
        <div class="d-inline-block mr-2">
          <span>Tipo enmienda: </span><strong>{{ amendment.type.title }}</strong>
        </div>
        <div class="d-inline-block mr-2" v-if="amendment.status">
          <span>Estatus: </span><strong>{{ amendment.status.title }}</strong>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  
  export default {
    name: 'AmendentHeader',
    props: {
      amendment: Object,
    },
    data() {
      return {
      }
    },
    methods: {
    },
    computed: {
    }
  }
</script>
